/** Largeur à partir de laquelle le menu fixe desktop est le comportement historique. */
export const ADMIN_NAV_DESKTOP_MIN_PX = 1024;

/**
 * Plafond tablette : iPad 12,9" paysage (1366) et tablettes Android courantes
 * (jusqu'à ~1600 CSS px). Au-delà, le menu fixe reste en place.
 */
export const ADMIN_NAV_TABLET_OVERLAY_MAX_PX = 1600;

/**
 * Menu superposé (mobile, ou tablette tactile) plutôt que colonne fixe.
 * Un poste souris, y compris une fenêtre étroite, conserve le menu fixe dès 1024 px.
 *
 * @param {{ viewportWidth: number, pointerCoarse: boolean }} input
 * @returns {boolean}
 */
export function shouldUseOverlayAdminNav({ viewportWidth, pointerCoarse }) {
  if (!Number.isFinite(viewportWidth)) return true;
  if (viewportWidth < ADMIN_NAV_DESKTOP_MIN_PX) return true;
  return Boolean(pointerCoarse) && viewportWidth <= ADMIN_NAV_TABLET_OVERLAY_MAX_PX;
}

export function overlayNavMediaQuery() {
  const mobileMax = ADMIN_NAV_DESKTOP_MIN_PX - 1;
  return `(max-width: ${mobileMax}px), ((min-width: ${ADMIN_NAV_DESKTOP_MIN_PX}px) and (max-width: ${ADMIN_NAV_TABLET_OVERLAY_MAX_PX}px) and (pointer: coarse))`;
}
